import { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

// New function to fetch error history
const getErrorHistory = async (testId, isCsqXp) => {
  try {
    const response = await api({
      method: 'post',
      url: `${QUALITY_SERVICE_API_URL}/hub/errors-history`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        testId,
        isCsqXp,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching error history:', error);
    throw error;
  }
};

const useErrorsHistory = (testId, isCsqXp = false) => {
  const [errorHistory, setErrorHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchErrorHistory = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getErrorHistory(testId, isCsqXp);
      setErrorHistory(result);
    } catch (err) {
      setError(err);
      console.error('Failed to fetch error history:', err);
    } finally {
      setLoading(false);
    }
  }, [testId, isCsqXp]);

  useEffect(() => {
    if (testId) {
      fetchErrorHistory();
    }
  }, [fetchErrorHistory, testId, isCsqXp]);

  return { errorHistory, loading, error };
};

export default useErrorsHistory; 